import { Checkbox, Typography } from "antd";
import { DateRangeForm, type DateRangeFormFields } from "./DateRangeForm";

const { Text } = Typography;

export interface InheritableDateRangeFields extends DateRangeFormFields {
  inheritDateRange: boolean;
}

interface DateRangeStepProps {
  value: InheritableDateRangeFields;
  onChange: (patch: Partial<InheritableDateRangeFields>) => void;
  itemIndex: number;
  inheritLabel?: string;
  description?: string;
  /** Show the "Dynamically controlled" row — the host widget's `dynamic.bindableSections`. */
  bindable?: boolean;
  /** Offer "Last N sessions" on the From edge — see DateRangeForm. */
  allowLatestN?: boolean;
}

export function DateRangeStep({
  value,
  onChange,
  itemIndex,
  inheritLabel = "Same as first",
  description,
  bindable = false,
  allowLatestN = false,
}: DateRangeStepProps) {
  const showInherit = itemIndex >= 1;

  return (
    <div className="awm-step-body">
      {showInherit && (
        <Checkbox
          checked={value.inheritDateRange}
          onChange={(e) => onChange({ inheritDateRange: e.target.checked })}
          style={{
            padding: "8px 10px",
            border: `1px solid ${value.inheritDateRange ? "#b0c9f0" : "#e0e5eb"}`,
            borderRadius: 8,
            background: value.inheritDateRange ? "#f0f5ff" : "#f7f9fb",
            width: "100%",
          }}
        >
          <div>
            <Text strong style={{ fontSize: 12 }}>{inheritLabel}</Text>
            <br />
            <Text type="secondary" style={{ fontSize: 11 }}>
              Uses the same date range. Uncheck to choose a different window.
            </Text>
          </div>
        </Checkbox>
      )}

      {(!showInherit || !value.inheritDateRange) && (
        <DateRangeForm
          value={value}
          onChange={onChange}
          description={description}
          bindable={bindable}
          allowLatestN={allowLatestN}
        />
      )}
    </div>
  );
}
